module.exports = __webpack_public_path__ + "static/img/address.0664b571.png";